import { createSlice } from "@reduxjs/toolkit"

export interface IProgramsFilters {
    created_on_start: string
    created_on_end: string
    state_id: { id: number; title: string }[]
    city_id: { id: number; title: string }[]
    account_id: { id: string; title: string }
    country_id: { id: number; title: string }
    region: { id: string; title: string }[]
    tag_ids: { id: number; title: string }[]
    created_by: { id: number; title: string }
}

const initialState = {
    selectedTab: 0,
    visibleColumns: [
        { name: "Country", visible: false },
        { name: "Region", visible: false },
        { name: "State", visible: false },
        { name: "City", visible: false },
    ],
    programsFilters: {
        created_on_start: "",
        created_on_end: "",
        state_id: [] as { id: number; title: string }[],
        city_id: [] as { id: number; title: string }[],
        account_id: {} as { id: string; title: string },
        country_id: {} as { id: number; title: string },
        created_by: {} as { id: number; title: string },
        region: [] as { id: string; title: string }[],
        tag_ids: [] as { id: number; title: string }[],
    } as IProgramsFilters,
    searchKey: "",
    page: 1,
    per_page: 10,
}

const ProgramsSlice = createSlice({
    name: "programs",
    initialState,
    reducers: {
        setSelectedTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setVisibleColumns: (state, action) => {
            state.visibleColumns = action?.payload
        },
        setProgramsFilters: (state, action) => {
            state.programsFilters = action.payload
        },
        setPage: (state, action) => {
            state.page = action.payload
        },
        setPerPage: (state, action) => {
            state.per_page = action.payload
        },
        setSearchKey: (state, action) => {
            state.searchKey = action.payload
        },
    },
})

export const { setSelectedTab, setVisibleColumns, setProgramsFilters, setPage, setPerPage, setSearchKey } = ProgramsSlice.actions
export default ProgramsSlice.reducer
